<style lang="less" scoped>
    .stock-picker{
        display: inline-block;
        width: 100%;
        vertical-align: middle;
        .ivu-poptip{
            width: 100%;
            /deep/ .ivu-poptip-rel{
                width: 100%;
            }
        }
    }
    .stock{
        margin-bottom: 5px;
        text-align: left;
        overflow: hidden;
        text-overflow: ellipsis;
        border: 1px solid #dddee1;
        padding: 5px 8px;
        cursor: pointer;
        &:hover{
            background: #f5f5f5;
        }
    }
    .sub-stocks{
        padding-left: 8px;
        white-space: normal;
    }
</style>
<template>
    <div class="stock-picker">
        <Poptip transfer width="250" :placement="placement">
            <div>
                <slot>请选择</slot>
            </div>
            <div slot="content">
                <i-input size="small" v-model="params.search" @on-enter="search" placeholder="搜索存货...">
                    <Button slot="append" icon="ios-search" @click="search" :loading="loading"></Button>
                </i-input>
                <div class="hr"></div>
                <div class="stock" v-for="stock in stocks" @click="selectStock(stock)" :key="stock.id">
                    <div>{{stock.uid || '无编码'}} - {{stock.name}}</div>
                    <div class="sub-stocks" v-for="sub_stock in stock.sub_stocks" :key="sub_stock.id">
                        {{sub_stock.uid}} - {{sub_stock.name}}
                    </div>
                </div>
            </div>
        </Poptip>
        <!--<Select :value="value" placeholder="请选择存货">
            <i-input size="small" v-model="params.search" @on-enter="search" placeholder="搜索存货...">
                <Button slot="append" icon="ios-search" @click="search" :loading="loading"></Button>
            </i-input>
            <Option :value="`${stock.uid}V${stock.new_version}`" :label="`${stock.uid}V${stock.new_version}`" v-for="stock in stocks" @click.native="selectStock(stock)" :key="stock.id">
                <div>{{stock.uid || '无编码'}} - {{stock.name}}</div>
                <div class="sub-stocks" v-for="sub_stock in stock.sub_stocks" :key="sub_stock.id">
                    {{sub_stock.uid}} - {{sub_stock.name}}
                </div>
            </Option>
        </Select>-->
    </div>
</template>
<script>
    export default {
        props: {
            value: {
                type: String,
            },
            placement: {
                type: String,
                default: 'bottom-start'
            }
        },
        data(){
            return {
                params: {
                    search: '',
                    page: 1,
                    per_page: 5
                },
                stocks: [],
                loading: false
            }
        },
        computed: {
            //
        },
        created(){
            //
        },
        mounted(){
            //
        },
        methods: {
            search(){
                this.loading = true;
                Util.ajax.get(Util.api.es_query_parent_stock, {
                    params: this.params
                }).then((response)=>{
                    return response.data;
                }).then((res)=>{
                    this.loading = false;
                    this.stocks = [];
                    if(res.code === 1){
                        let data = res.data;
                        this.stocks = data.stocks;
                        if(this.stocks.length === 0){
                            this.$Message.warning('未搜索到相关存货');
                        }
                    }else{
                        this.$Modal.error({
                            title: '错误',
                            content: res.msg
                        });
                    }
                }).catch((e)=>{
                    this.loading = false;
                    this.$Modal.error({
                        title: '错误',
                        content: e.message
                    });
                });
            },
            selectStock(stock){
                if(!stock.uid){
                    this.$Modal.warning({title: '提示', content: '未分配存货编码，无法选择'});
                    return;
                }
                this.$emit('on-select', stock, stock.new_version);
                // this.$emit('input', `${stock.uid}V${stock.new_version}`);
                this.$parent.$emit('on-form-blur');
                document.body.click();
            }
        }
    }
</script>
